import { useIsMobileView } from '@nuxt-monorepo/ui/composables/isMobileView';
import screens from '#tailwind-config/theme/screens';

export default function useLDContext() {
    const { isMobileView } = useIsMobileView(screens.md);
    const config = useRuntimeConfig();
    const route = useRoute();
    const STORYBLOK_FOLDER = config?.public?.STORYBLOK_FOLDER;

    const anonymousUserContext = {
        kind: 'user',
        anonymous: true,
    };

    const fullPathWithoutQuery = route.fullPath.split('?')[0];
    const pageUrl = fullPathWithoutQuery.slice(1).replaceAll('/', '-');
    const pageContext = {
        kind: 'page',
        key: `${STORYBLOK_FOLDER}-page`,
        page: pageUrl,
    };

    const deviceContext = {
        kind: 'device',
        key: 'device',
        deviceType: isMobileView.value ? 'mobile' : 'desktop',
    };

    return {
        kind: 'multi',
        user: anonymousUserContext,
        page: pageContext,
        device: deviceContext,
    };
}
